import { render, staticRenderFns } from "./PhysicianRoomList.vue?vue&type=template&id=30ffd593&"
import script from "./PhysicianRoomList.vue?vue&type=script&lang=ts&"
export * from "./PhysicianRoomList.vue?vue&type=script&lang=ts&"
import style0 from "./PhysicianRoomList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports